var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1518_2789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0018 0H9.99822C4.47635 0 0 4.47715 0 10C0 15.5228 4.47635 20 9.99822 20H27.0018C32.5236 20 37 15.5228 37 10C37 4.47715 32.5236 0 27.0018 0Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80035 5.14148H16.5715V10.5595C16.5715 11.9485 15.83 13.2323 14.6281 13.9268L11.1859 15.9146L7.74375 13.9268C6.54032 13.2323 5.80035 11.9485 5.80035 10.5595V5.14148Z",
    fill: "#FFDD2D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75551 7.99341V9.67788C8.98645 9.41704 9.40435 9.24105 9.88353 9.24105H10.4035V11.2005C10.4035 11.7222 10.2622 12.1779 10.0516 12.4293H12.3155C12.1066 12.1779 11.9652 11.7222 11.9652 11.2021V9.24262H12.4852C12.9644 9.24262 13.3838 9.41861 13.6132 9.67945V7.99498H8.75394L8.75551 7.99341Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7206 13.3972V7.03015H20.7128V13.3972H22.7206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5595 13.3972C30.0999 13.3972 31.3567 12.0459 31.3567 10.2137C31.3567 8.3815 30.0983 7.03015 27.7732 7.03015H24.1896V13.3972H27.5611H27.5595ZM27.3568 8.55435C28.7346 8.55435 29.3097 9.17031 29.3097 10.2137C29.3097 11.1769 28.7362 11.9123 27.3568 11.9123H26.1267V8.55435H27.3568Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1518_2789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbankIcon);
export default __webpack_public_path__ + "static/media/tbank-icon.de97eb12060f4249c7a420202eb21921.svg";
export { ForwardRef as ReactComponent };